<template>
  <bk-page v-if="!userInfo || !userInfo.id || (!favoriteShopList || favoriteShopList.length == 0)" class="favoritesPage noData">

    <bk-view class="view-noData">

      <bk-view v-if="!userInfo || !userInfo.id" class="view-tip">
        <bk-button login-auth-flag type="text" lang-code="favorites_btn_login" @loginSuccess="initData"></bk-button>
      </bk-view>
      <bk-view v-if="favoriteShopList" class="view-tip">
        <bk-lang code="favorites_text_noData"></bk-lang>
      </bk-view>
    </bk-view>


  </bk-page>
  <bk-page v-else class="favoritesPage">

    <bk-view class="view-favoritesShopList">

      <bk-view class="view-list">

        <ShopItem v-for="item in favoriteShopList" :item="item"></ShopItem>

        <bk-view v-if="favoriteShopList" class="view-tip">
          <bk-lang code="favorites_text_noMoreData"></bk-lang>
        </bk-view>

      </bk-view>

    </bk-view>


  </bk-page>

</template>

<script>

	import {shopReq} from '@/reqService/index';
	import ShopItem from '../home/subViews/shopItem/shopItem.vue';
	import BkButton from '../../components/bk-base/bk-button/bk-button';
	import BkLang from '../../components/bk-base/bk-lang/bk-lang';

	export default {
		name: 'favorites',
		components: {
			BkLang,
			BkButton,
			ShopItem,
		},
		data () {
			return {
				navBarInfo: {},
				favoriteShopList: undefined, // 收藏门店

				userInfo: this.$bk_getUserInfo(),

				locInfo: {
					lat: 31.23522,
					lng: 121.48054,
				}
			};
		},
		created () {

		},
		activated () {
			this.initData();
		},
		methods: {
			initData () {

				this.userInfo = this.$bk_getUserInfo();

				bkLog.log('用户：', this.userInfo);

				if (!this.userInfo || !this.userInfo.id) {
					return;
				}

				this.requestGetMyFavoriteShops();
			},

			async requestGetMyFavoriteShops () {

				let parame = {
        ...this.locInfo,
          pageNum: 1,
          pageSize: 100
				};

				let res = await shopReq.requestGetMyFavoriteShops(this, parame).catch(() => {});

				//
				this.favoriteShopList = res.list || [];
			},
		}
	};
</script>

<style lang="less">

@import "./favorites";

</style>